import { ROUTER_PATHS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetSolicitudTransferenciaInventario } from "@/shared/actions/erp";
import { GeneralTable, TableTabsScene } from "@/shared/components/ui";
import { useTableSolicitudTransferenciaInventario } from "@/shared/hooks/useTableSolicitudTransferenciaInventario";
import { EstadoSolicitudTransferencia, IDataSolicitudTraslado } from "@/shared/interfaces";
import { useNavigate } from "react-router-dom";


interface SolicitudTransferenciaInventarioEsperaPageProps {
  estado: EstadoSolicitudTransferencia;
  action?: boolean;

}

const SolicitudTransferenciaInventarioTable = ({ estado, action = false }: SolicitudTransferenciaInventarioEsperaPageProps) => {


  const { columnaBase } = useTableSolicitudTransferenciaInventario();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const { isLoading, data: transferenciaProducto,
    isRefetching, } = useFetchGetSolicitudTransferenciaInventario(
      {
        page: pageIndex + 1,
        page_size: 10,
        estado_solicitud: estado,
        ...filterObject,
        filterByState: false
      }
    );

  const navigate = useNavigate();

  return (
    <>
      <TableTabsScene
        globalFilter={globalFilter}
        onChangeFilter={onChangeFilter}
        showFieldFilter={false}
      >
        <GeneralTable<IDataSolicitudTraslado>
          columns={columnaBase}
          data={transferenciaProducto?.data.data || []}

          isLoading={isLoading}
          isRefetching={isRefetching}

          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={transferenciaProducto?.data.count}


          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}


          // crud
          positionActionsColumn='first'
          actionsColumnSize={120}
          canDelete={false}
          canEdit={action}
          enableColumnActions={true}
          enableEditing={action}
          onEdit={(r) => {
            navigate(ROUTER_PATHS.inventario.revisarSolicitudInventarioNav + r.id_solicitudtraslado);
          }}

        />
      </TableTabsScene>


    </>

  );
}


export default SolicitudTransferenciaInventarioTable;